module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-btn', {
    attrs: {
      "fab": "",
      "bottom": "",
      "right": "",
      "color": "pink",
      "dark": "",
      "fixed": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialog = !_vm.dialog
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "800px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-4 py-4 title"
  }, [_vm._v("\n        Add Booking\n      ")]), _vm._v(" "), _c('v-container', {
    staticClass: "pa-4",
    attrs: {
      "grid-list-sm": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "row": "",
      "wrap": ""
    }
  }, [_vm._t("CaseAndAmount", null, {
    "casesList": _vm.casesList,
    "selectedCase": _vm.selectedCase,
    "amount": _vm.amount
  }), _vm._v(" "), _vm._t("ItemsSelection", null, {
    "selectedItemType": _vm.selectedItemType,
    "inventoriesList": _vm.inventoriesList,
    "servicesList": _vm.servicesList,
    "caseManagersList": _vm.caseManagersList,
    "selectedInventory": _vm.selectedInventory,
    "selectedService": _vm.selectedService,
    "selectedCaseManager": _vm.selectedCaseManager,
    "amount": _vm.amount
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-menu', {
    model: {
      value: (_vm.menuDateStart),
      callback: function($$v) {
        _vm.menuDateStart = $$v
      },
      expression: "menuDateStart"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Select start date",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.dateStart),
      callback: function($$v) {
        _vm.dateStart = $$v
      },
      expression: "dateStart"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "reactive": ""
    },
    model: {
      value: (_vm.dateStart),
      callback: function($$v) {
        _vm.dateStart = $$v
      },
      expression: "dateStart"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false
    },
    model: {
      value: (_vm.menuTimeStart.state),
      callback: function($$v) {
        _vm.$set(_vm.menuTimeStart, "state", $$v)
      },
      expression: "menuTimeStart.state"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Select start time",
      "prepend-icon": "alarm",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.timeStart),
      callback: function($$v) {
        _vm.timeStart = $$v
      },
      expression: "timeStart"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    model: {
      value: (_vm.timeStart),
      callback: function($$v) {
        _vm.timeStart = $$v
      },
      expression: "timeStart"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-menu', {
    model: {
      value: (_vm.menuDateEnd),
      callback: function($$v) {
        _vm.menuDateEnd = $$v
      },
      expression: "menuDateEnd"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Select end date",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.dateEnd),
      callback: function($$v) {
        _vm.dateEnd = $$v
      },
      expression: "dateEnd"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "reactive": ""
    },
    model: {
      value: (_vm.dateEnd),
      callback: function($$v) {
        _vm.dateEnd = $$v
      },
      expression: "dateEnd"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false
    },
    model: {
      value: (_vm.menuTimeEnd.state),
      callback: function($$v) {
        _vm.$set(_vm.menuTimeEnd, "state", $$v)
      },
      expression: "menuTimeEnd.state"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Select end time",
      "prepend-icon": "alarm",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.timeEnd),
      callback: function($$v) {
        _vm.timeEnd = $$v
      },
      expression: "timeEnd"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    model: {
      value: (_vm.timeEnd),
      callback: function($$v) {
        _vm.timeEnd = $$v
      },
      expression: "timeEnd"
    }
  })], 1)], 1)], 2)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.saveNew
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('AppMainDialog', {
    attrs: {
      "open": _vm.dialogOpen,
      "message": _vm.dialogMessage
    },
    on: {
      "closedialog": function($event) {
        _vm.dialogOpen = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66dde026","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppAddBookingButton.vue
// module id = 977
// module chunks = 1